<div class="flex flex-col">
    <div class="inline-flex rounded-md w-full" role="group">
        @for (option of options; track option.id; let i = $index) {
            <button
                [id]="option.id"
                type="button"
                (click)="onValueSelected(option.value)"
                (keydown.enter)="onValueSelected(option.value)"
                [disabled]="isOptionDisabled(option)"
                [class]="
                    isSelected(option.value)
                        ? 'bg-primary-100 text-primary-800'
                        : 'text-tertiary-900 hover:bg-tertiary-100'
                "
                [ngClass]="{
                    'bg-tertiary-100 cursor-default': isOptionDisabled(option),
                    'rounded-l-md': i === 0,
                    'rounded-r-md': i === options.length - 1,
                }"
                class="w-full h-[42px] relative flex items-center justify-center px-5 py-2 text-sm font-medium border cursor-pointer border-tertiary-300 focus:z-10 focus:outline-none focus:ring-1 focus:ring-primary-700"
            >
                @if (isSelected(option.value)) {
                    <mat-icon class="scale-75 me-1" aria-hidden="true"
                        >check</mat-icon
                    >
                }
                <span [innerHTML]="option.label"></span>
            </button>
        }
    </div>

    <div class="inline-flex rounded-md w-full items-center">
        @for (option of options; track option.id) {
            @if (option.description) {
                <label
                    [for]="option.id"
                    class="font-medium w-full text-center px-6 text-sm text-tertiary-600 mt-1"
                    >{{ option.description }}</label
                >
            }
        }
    </div>
</div>
